import { Skeleton, Statistic } from 'antd';
import React, { useState, useEffect } from 'react';
import { CheckBalance } from '../../../apis/Brand/Credit/CheckBalance';
import { dispatch, useGlobalState } from '../../../store/state';
import CurrencyIcon from '../../Common/CurrencyIcon';
// import './CampaignEarningsComponent.styles.scss';

const CampaignCreditsComponent = ({ title, subtitle, className }) => {
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');
  const [loading, setLoading] = useState(true);
  // const [amount,setAmount]= useState(0)
  useEffect(() => {
    CheckBalance(user.accessToken, company.selected.id).then(({ response, status })=>{
      console.log('balance', response);
      if (status === 200) {
        dispatch({
          type: 'SET_COMPANY',
          payload: {
            ...company,
            credit: {
              ...company.credit,
              balance: response.wallet_balance,
            },
          },
        });
        setLoading(false);
      } else {
        console.log('error while getting balance', response);
      }
    });
  }, []);

  return loading? (
    <div className={`col-md-3 px-2 ${className}`}>
      <div className="common_card p-3 h-100 camp_stat_counts">
        <Skeleton active
          paragraph={{ rows: 1 }}/>
      </div>
    </div>
  ):(
    <div className={`col-md-3 px-2 ${className}`}>
      <div className="common_card p-3 h-100 camp_stat_counts">
        <h5 >{title}</h5>
        <ul className="d-block">
          <li>
            <h6><span style={{ verticalAlign: '2px' }}>{CurrencyIcon()}</span><Statistic value={company?.credit.balance}
              precision={0}
              className="custom_number_format"
              style={{ lineHeight: 1 }}/></h6>
            <p>{subtitle}</p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CampaignCreditsComponent;
